import { render } from "./MovieHomePage.vue?vue&type=template&id=677dd0f2&ts=true"
import script from "./MovieHomePage.vue?vue&type=script&lang=ts"
export * from "./MovieHomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__